module.exports = __webpack_public_path__ + "static/joc_05-ebe19751ed8ecf9810469902a88ed32a.jpg";